// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__AQXNi","description":"MealItem_description__euUye","price":"MealItem_price__RBJAk"};